module.exports = __webpack_public_path__ + "img/whoop.267e725e.png";